import React from 'react';
import { Section, Card, Button } from '../../index';

/**
 * SuccessHero: Large success state for post-provisioning
 */
export const SuccessHero = ({
    title,
    subtitle,
    icon,
    actions,
    maxWidth = '800px',
    style
}) => {
    return (
        <Section style={{ display: 'flex', justifyContent: 'center', margin: '2rem 0', ...style }}>
            <Card level={1} variant="feature" style={{
                padding: '5rem 4rem',
                textAlign: 'center',
                maxWidth: maxWidth,
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '2.5rem'
            }}>
                {icon && (
                    <div style={{
                        color: 'var(--color-success)',
                        background: 'var(--color-success-light)',
                        width: '80px',
                        height: '80px',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        {React.cloneElement(icon, { size: 48 })}
                    </div>
                )}

                <div>
                    <h1 style={{
                        fontSize: '2.5rem',
                        fontWeight: 900,
                        letterSpacing: '-0.02em',
                        margin: '0 0 1rem 0',
                        textTransform: 'uppercase'
                    }}>
                        {title}
                    </h1>
                    <p style={{
                        fontSize: '1.1rem',
                        opacity: 0.7,
                        maxWidth: '500px',
                        margin: '0 auto',
                        lineHeight: 1.6
                    }}>
                        {subtitle}
                    </p>
                </div>

                {actions && (
                    <div style={{ display: 'flex', gap: '1rem', marginTop: '1rem' }}>
                        {actions}
                    </div>
                )}
            </Card>
        </Section>
    );
};

/**
 * FormActionGroup: Consistent action layout for bottom of forms
 */
export const FormActionGroup = ({
    onSave,
    onCancel,
    saveLabel = 'SAVE',
    cancelLabel = 'CANCEL',
    loading = false,
    isEdit = true,
    type = 'button',
    style
}) => {
    return (
        <div style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '1rem',
            marginTop: '3.5rem',
            paddingTop: '2rem',
            borderTop: '1px solid var(--color-border-light)',
            ...style
        }}>
            <Button
                variant="outline"
                onClick={onCancel}
                disabled={loading}
                type="button"
            >
                {cancelLabel}
            </Button>
            <Button
                variant="primary"
                onClick={onSave}
                loading={loading}
                type={type}
            >
                {loading ? 'SAVING...' : saveLabel}
            </Button>
        </div>
    );
};
